var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxBoldAirpods(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.78 2c-1.04 0-1.98.42-2.67 1.11C2.42 3.8 2 4.74 2 5.78c0 2.08 1.7 3.78 3.78 3.78h.94v7.55c0 .73.42 1.36 1.03 1.67a1.773 1.773 0 0 0 1.5.1c.73-.26 1.25-.95 1.25-1.77V4.83C10.5 3.28 9.22 2 7.67 2H5.78zm.75 4.72c0 .41-.34.75-.75.75-.93 0-1.69-.76-1.69-1.7s.76-1.69 1.69-1.69c.41 0 .75.34.75.75s-.34.75-.75.75a.19.19 0 0 0-.19.19c0 .1.08.2.19.2.41 0 .75.34.75.75zM18.22 2h-1.89a2.84 2.84 0 0 0-2.83 2.83v12.28c0 .82.52 1.51 1.25 1.77a1.773 1.773 0 0 0 1.5-.1c.61-.31 1.03-.94 1.03-1.67V9.56h.94c2.08 0 3.78-1.7 3.78-3.78 0-1.04-.42-1.98-1.11-2.67A3.756 3.756 0 0 0 18.22 2zm-.75 4.72c0-.41.34-.75.75-.75.11 0 .19-.09.19-.2a.19.19 0 0 0-.19-.19c-.41 0-.75-.34-.75-.75s.34-.75.75-.75a1.694 1.694 0 0 1 0 3.39c-.41 0-.75-.34-.75-.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25 22.001c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-3.22a1.773 1.773 0 0 0 1.5.1v3.12zM16.25 22.001c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-3.12a1.773 1.773 0 0 0 1.5-.1v3.22z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldAirpods);
export default __webpack_public_path__ + "static/media/vuesax-bold-airpods.058787ed2d7f7f37001586ec5033080e.svg";
export { ForwardRef as ReactComponent };